module.exports = __webpack_public_path__ + "components/media-kit/static/app-desktop-6055ae14943b792c60f4c5ec49eb1941.png";